import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { CategoryProductAttributeDto } from './CategoryProductAttributeDto'
/**
* Class CategoryAttributesListDto
*  Информация об атрибутах категории
*/
export class CategoryAttributesListDto extends ActiveModel {

/**
  * @property attributes
  * Информация обо всех атрибутах категории<br>  */
  @ActiveField({
    factory: [CategoryProductAttributeDto, () => undefined]
  })
  attributes?: Array<CategoryProductAttributeDto>
}
